import { IWebhookService, WebhookAddress } from '@truckdown/systems';
import context from '@truckdown/components-systems';
import { showMessage } from "../../Utilities/Utilities";
import { defineComponent, ref, Ref } from "vue";
import { required, helpers, requiredIf } from '@vuelidate/validators';
import { useVuelidate, Validation } from '@vuelidate/core';

interface IData {
    isLoading: Ref<boolean>,
    code: Ref<string>,
    validation: Ref<Validation<any>>
}

const getData = function () {
    let data = {
        isLoading: ref<boolean>(false),
        code: ref<string>('')
    } as IData;

    data.validation = useVuelidate(getValidationRules(data), data);

    return data;
}

const getValidationRules = function (data: IData) {
    return {
        "code": {
            required: helpers.withMessage('Please enter a verification code', required)
        }
    };
};

const getMethods = function (address: WebhookAddress, data: IData, ctx: any) {
    return {
        cancelClick: function () {
            ctx.emit('cancel');
        },
        sendCode: async function () {
            if (!data.isLoading.value) {
                try {
                    data.isLoading.value = true;

                    let service = await context.getService<IWebhookService>('IWebhookService');

                    let res = await service.sendValidationCode(address);
                    if (!res.ok) {
                        showMessage('An error occured while trying to send a webhook verification code.', "danger", true, true);
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('An error occured while trying to send a webhook verification code.', "danger", true, true);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        },
        verifyClick: async function () {
            if (!data.isLoading.value) {
                try {
                    data.isLoading.value = true;

                    let isValid = await data.validation.value.$validate();
                    if (isValid) {
                        let service = await context.getService<IWebhookService>('IWebhookService');
                        let res = await service.validateCode(address, data.code.value);
                        if (res.ok) {
                            let verifyRes = await service.isVerified(address, res.message ?? '');
                            if (verifyRes.ok) {
                                ctx.emit('verified', address);
                            } else {
                                showMessage('Invalid verification code.', "danger", true, true);
                            }
                        } else {
                            showMessage('Invalid verification code.', "danger", true, true);
                        }
                    }
                }
                catch (err) {
                    console.log(err);
                    showMessage('An error occured while trying to verify your webhook.', "danger", true, true);
                }
                finally {
                    data.isLoading.value = false;
                }
            }
        }
    };
}

export default defineComponent({
    props: {
        address: {
            type: Object as () => WebhookAddress,
            required: true
        }
    },
    components: {
    },
    emits: ['cancel', 'verified'],
    setup: function (props, ctx) {
        let data = getData();
        let methods = getMethods(props.address, data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});